<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

        <div class="content" v-if="this.$route.query.id == undefined">
          <div class="container">
            <div class="floating-buttons">
              <button class="fl-button" @click="popup.request = true" title="Új igénylés">
                <i class="fa fa-plus"></i>
              </button>
            </div>

            <h1>Vonalkód igénylések</h1>

            <div v-if="requests.length > 0" class="table-with-title">
              <table ref="abc" class="list">
                <tr>
                  <th>Igénylő</th>
                  <th>Igénylés dátuma</th>
                  <th>Csoport</th>
                  <th style="text-align: center;">Mennyiség</th>
                  <th>Megjegyzés</th>
                  <th style="text-align: center;">Jóváhagyva</th>
                  <th>Jóváhagyás dátuma</th>
                  <th></th>
                </tr>

                <tr v-for="request in requests">
                  <td>{{ request.username }}</td>
                  <td>{{ request.request_date }}</td>
                  <td>{{ request.groupname }}</td>
                  <td style="text-align: center;">{{ request.barcode_email_sent_amount }} / {{ request.amount }}</td>
                  <td>{{ request.comment }}</td>
                  <td style="text-align: center;">
                    <i v-if="request.approved == 0" class="fa fa-minus"></i>
                    <i v-if="request.approved == 1" class="fa fa-check"></i>
                  </td>
                  <td>{{ request.approved_date }}</td>
                  <td class="buttons">
                    <button v-if="request.approved == 1" @click="setBarcodes(request.id)" class="small-button" title="Vonalkódok beállítása"><i class="fa fa-cog"></i></button>
                    <button v-if="request.approved == 0 && request.user_id == $root.user.element_id" @click="request_id = request.id; popup.request = true" class="small-button" title="Igénylés módosítása"><i class="fa fa-pencil-alt"></i></button>
                    <button v-if="request.approved == 0 && request.user_id == $root.user.element_id" @click="del(request.id)" class="small-button" title="Igénylés törlése"><i class="fa fa-trash-alt"></i></button>
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              Még nem igényelt vonalkódokat.
            </div>
          </div>
          <BarcodeRequestPopup :id="request_id" @close="popup.request = false;" @success="getRequests" v-if="popup.request"/>
        </div>

      <BarcodeRequestSetup @save_start="is_save = true;" @save_finish="is_save = false;" v-if="this.$route.query.id != undefined"/>

      <HTMLFooter></HTMLFooter>
      <ProgressInfo :show="is_save"/>
    </div>
  </div>
</template>

<script>
import BarcodeRequestPopup from './barcode/popup.vue';
import BarcodeRequestSetup from './barcode/setup.vue';

export default {
  components: {
    BarcodeRequestPopup,
    BarcodeRequestSetup
  },
  data() {
    return {
      requests: [],
      unapproved_amount: 0,
      request_id: 0,
      is_save: false,
      popup: {
        request: false
      }
    };
  },
  mounted: function() {
    this.getRequests();
  },
  methods: {
    setBarcodes: function(id) {
      this.$router.push({
        path: '/barcode_request',
        query: {
          id: id
        }
      })
    },

    getRequests: function() {
      var _this = this;

      this.request_id = 0;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('barcodeRequests/' + _this.$root.user.apikey, {
          success: function(response) {
            _this.requests = response.requests;
            _this.unapproved_amount = response.unapproved_amount;
          }
        });
      });
    },

    del: function(id) {
      var _this = this;

      this.$root.ajax('barcodeRequest/del/' + _this.$root.user.apikey + '/' + id, {
        success: function(response) {
          _this.getRequests();
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// barcode_request.vue?2ac5ad36